import { useMemo } from "react"
import { aDuration, aProgress, useAtomValue } from "~/atoms"
import { cn } from "~/utils"

export default function CurrentTime({ className }: { className?: string }) {
  const progress = useAtomValue(aProgress)
  const duration = useAtomValue(aDuration)

  const inHours = useMemo(() => Math.floor(duration / 3600) > 0, [duration])

  const progressTime = useMemo(() => {
    return new Date(progress * 1000).toISOString().slice(inHours ? 11 : 14, 19)
  }, [progress, inHours])

  const durationTime = useMemo(() => {
    return new Date(duration * 1000).toISOString().slice(inHours ? 11 : 14, 19)
  }, [duration, inHours])

  return (
    <div
      className={cn(
        "ml-2 flex items-center gap-2 text-xs text-white sm:text-sm",
        className
      )}
    >
      <span className={cn(inHours ? "w-13 sm:w-16" : "w-8 sm:w-10")}>
        {progressTime}
      </span>
      <span className="hidden sm:block">/</span>
      <span
        className={cn(
          "hidden sm:block",
          inHours ? "w-13 sm:w-16" : "w-8 sm:w-10",
          "text-right"
        )}
      >
        {durationTime}
      </span>
    </div>
  )
}
